<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  import type { GatButtonProps } from '@gat-ship/vue-components'
  export interface DataListItemActionProps extends GatButtonProps {
    class?: HTMLAttributes['class']
    /** The icon to display in the button. If not provided, the button will not display an icon.
     * @default 'EllipsisVertical'
     */
    icon?: GatIconProps['icon']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  import type { GatIconProps } from '@gat-ship/vue-components'
  const props = withDefaults(defineProps<DataListItemActionProps>(), {
    icon: 'EllipsisVertical'
  })
</script>

<template>
  <gat-button
    v-bind="props"
    :variant="props.variant ?? 'ghost'"
    :size="props.size ?? 'icon'"
    :icon="props.icon ?? 'EllipsisVertical'"
    :class="cn('group-hover:bg-background hover:bg-neutral-300', props.class)"
  >
    <slot />
  </gat-button>
</template>
